import { IConfigComponent } from '@ts/ui-models';
import GlobalDataGrid, { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';
import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';
import { generateGlobalColumns, IDataGridConfig } from '@ts/storybook';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('groupTemplate');

interface IEntityProps {
  inheritedProps?: any;
}

const GroupTemplates = (props: IEntityProps) => {
  const { inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
    sortModel: [{ field: 'name', sort: 'asc' }],
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({
      ...props,
      configComponent: defaultConfigComponent,
      isEditable: true,
      isFilterable: true,
      isSortable: true,
    });
    return [globalCells.id(), globalCells.name()];
  }, [props, defaultConfigComponent]);

  return (
    <WrapperDataGrid
      configComponent={defaultConfigComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      customDeleteModal={{ message: 'This will also erase associations related to the item' }}
      inheritedProps={inheritedProps}
      enabledFilters //V3
      enabledSort //V3
    />
  );
};

export default GroupTemplates;
